import Phaser from 'phaser';
import ABCyaPhaser from '@abcya/abcya_phaser';
import BeginGameOverlay from './BeginGameOverlay';
import GameOverOverlay from './GameOverOverlay';

export default class HudDisplay extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.coverShape = this.scene.add.rectangle(0, 0, this.scene.scale.width, this.scene.scale.height, '0xFFFFFF').setOrigin(0);
    this.coverShape.alpha = 0.4;
    this.add(this.coverShape);

    this.scoreContainer = this.scene.add.container();
    this.add(this.scoreContainer);
    this.scoreBox = this.scene.add.rectangle(0, 12, 96, 68, 0xef4136).setOrigin(0);
    this.scoreContainer.add(this.scoreBox);

    this.scoreDisplay = this.scene.add.bitmapText(0, 0, 'pixelFont', '0', 48).setOrigin(0);
    this.scoreDisplay.x = this.scene.scale.width / 2 - this.scoreDisplay.width / 2;
    this.scoreDisplay.y = 22;
    this.scoreContainer.add(this.scoreDisplay);

    this.beginOverlay = new BeginGameOverlay(this.scene);
    this.add(this.beginOverlay);

    this.gameOverOverlay = new GameOverOverlay(this.scene);
    this.add(this.gameOverOverlay);

    this.coverShape.visible = false;
    this.beginOverlay.visible = false;
    this.gameOverOverlay.visible = false;
    this.scoreContainer.visible = false;
  }

  initScore() {
    this.scoreDisplay.text = '0';
    this.scoreDisplay.x = Math.floor(96 / 2 - this.scoreDisplay.width / 2);
    this.scoreContainer.x = this.scene.scale.width;

    this.scoreContainer.visible = true;

    const x = Math.floor(this.scene.scale.width / 2 - 86 / 2);
    ABCyaPhaser.Tweens.addTween(this.scoreContainer, 1000, { x }, Phaser.Math.Easing.Quadratic.Out);
  };

  updateScore(score) {
    this.scoreDisplay.text = score.toString();
    this.scoreDisplay.x = Math.floor(96 / 2 - this.scoreDisplay.width / 2);
  };

  activateBegin() {
    this.beginOverlay.visible = true;
    this.beginOverlay.activate();

    this.beginOverlay.x = this.scene.scale.width;
    ABCyaPhaser.Tweens.addTween(this.beginOverlay, 700, { x: 0 }, Phaser.Math.Easing.Linear);
  };

  deactivateBegin() {
    this.beginOverlay.deactivate();

    this.initScore();

    ABCyaPhaser.Tweens.addTween(this.beginOverlay, 700, { x: -this.scene.scale.width }, Phaser.Math.Easing.Linear, () => {
      this.beginOverlay.visible = false;
    });

    this.scene.tweens.killTweensOf(this.gameOverOverlay);
    this.gameOverOverlay.x = this.scene.scale.width;
    this.gameOverOverlay.visible = false;
  };

  showGameOver(score, best) {
    console.log('showing over');
    this.gameOverOverlay.displayGameOver(score, best);
    this.gameOverOverlay.x = this.scene.scale.width;

    ABCyaPhaser.Tweens.addTween(this.gameOverOverlay, 1200, { x: 0 }, Phaser.Math.Easing.Quadratic.Out, () => {
      this.showStartOver();
    });

    this.coverShape.alpha = 0.4;
    this.coverShape.visible = true;
    this.gameOverOverlay.visible = true;

    ABCyaPhaser.Tweens.addTween(this.scoreContainer, 1200, { x: -100 }, Phaser.Math.Easing.Quadratic.Out, () => {
      this.scoreContainer.visible = false;
    });
  };

  showStartOver() {
    this.gameOverTween = null;
    this.gameOverOverlay.showGo();
  };

  hideGameOver() {
    ABCyaPhaser.Tweens.addTween(this.gameOverOverlay, 700, { x: -this.scene.scale.width }, Phaser.Math.Easing.Quadratic.Out, () => {
      this.gameOverOverlay.visible = false;
    });

    this.coverShape.alpha = 1;
    this.coverShape.visible = true;

    ABCyaPhaser.Tweens.addTween(this.coverShape, 1000, { delay: 800, alpha: 0 }, Phaser.Math.Easing.Quadratic.Out, () => {
      this.doStartOver();
    });
  };

  doStartOver() {
    this.scene.startOver();
  };
}